function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.68 6.18a6.5 6.5 0 106.5 6.5 6.49 6.49 0 00-6.5-6.5zm0 10.72a4.23 4.23 0 114.23-4.23 4.23 4.23 0 01-4.23 4.23zm8.28-11a1.52 1.52 0 11-1.51-1.5 1.51 1.51 0 011.51 1.51zm4.3 1.55a7.5 7.5 0 00-2.04-5.31A7.55 7.55 0 0017.9.09c-2.09-.12-8.36-.12-10.46 0a7.54 7.54 0 00-5.3 2.04A7.53 7.53 0 00.08 7.44c-.12 2.1-.12 8.37 0 10.46a7.5 7.5 0 002.05 5.31 7.56 7.56 0 005.3 2.05c2.1.12 8.38.12 10.47 0a7.5 7.5 0 005.31-2.05 7.55 7.55 0 002.05-5.3c.12-2.1.12-8.37 0-10.46zm-2.7 12.7a4.28 4.28 0 01-2.4 2.4c-1.68.67-5.63.52-7.48.52s-5.8.14-7.47-.51a4.28 4.28 0 01-2.41-2.41c-.66-1.67-.51-5.63-.51-7.48s-.15-5.8.5-7.47a4.28 4.28 0 012.42-2.4c1.67-.67 5.63-.52 7.47-.52s5.81-.14 7.47.51a4.28 4.28 0 012.41 2.41c.67 1.67.52 5.63.52 7.47s.15 5.81-.52 7.48z",
  fill: "#f7f7f7"
});

var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.5,
    height: 28.5,
    viewBox: "0 0 25 25"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/InstagramIcon.88cf620b.svg";
export { SvgInstagramIcon as ReactComponent };